import styled from 'styled-components';
import { colors } from 'global/colors';

export const Heading = styled.h4`
  margin: 15px 0;
  color: ${colors.fsDarkBlue};
`;
